const PrivacyPolicyMetaAd = () => {
    return (<div>Privacy Policy

        This campaign is hosted on Instagram and does not collect any personal data directly. Any interaction with the content, such as likes or comments, is governed by Instagram's privacy policy.
        
        We do not store, share, or access your personal information. All data related to this campaign is handled and processed by Meta Platforms, Inc. in accordance with their Privacy Policy.
        
        By interacting with our content, you acknowledge that your use of Instagram is subject to Meta's terms and privacy practices.
        
        If you have any questions about this campaign, feel free to contact us at badkuzu@gmail.com.</div>)
}

export default PrivacyPolicyMetaAd;
